// extracted by mini-css-extract-plugin
export var checkbox = "_7g-0";
export var circle = "_7g-3";
export var horizontalContainer = "_7g-7";
export var sm = "_7g-5";
export var switch0 = "_7g-2";
export var switchDisabled = "_7g-8";
export var switchEnabled = "_7g-1";
export var textSwitchContainer = "_7g-9";
export var textSwitchOption = "_7g-a";
export var textSwitchOptionSelected = "_7g-b";
export var verticalContainer = "_7g-6";
export var xs = "_7g-4";